import React, { FC } from "react";
import { useUser } from "../../contexts/UserProvider";
import { Redirect } from "react-router-dom";

export const withAuth = (Component: FC) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useUser();
  return <>{user ? <Component /> : <Redirect to="/login" />}</>;
};
